import { HashMap } from '../../utils/objectTransformers';
import { ExternalUserShort } from '../externalUser';
import { EXERCISE_TYPE } from './exercise';

export enum ROUTINE_TYPES {
  TEMPLATE = 'template',
  USER = 'user',
}

interface RoutineChange {
  date: Date;
  fieldsUpdated: string[];
}

interface BaseRoutineExercise {
  name: string;
  exerciseId: string;
  exerciseType: EXERCISE_TYPE;
  weight?: number;
  sets?: number;
  videoUrl?: string;
  imageUrl?: string;
  rir?: number;
  rpe?: number;
  comment?: string;
}
export interface RoutineRepetitionExercise extends BaseRoutineExercise {
  repetitions?: number;
}
export interface RoutineDurationExercise extends BaseRoutineExercise {
  duration?: number;
}
export type RoutineExercise = RoutineRepetitionExercise | RoutineDurationExercise;

export type RoutineExerciseHashMap = HashMap<string, RoutineExercise>;

// Nuevo tipo que puede ser un ejercicio individual o una superserie
export type ExerciseOrSuperset = RoutineExercise | RoutineExercise[];

export interface ExerciseDay {
  dayNumber: number;
  exercises: ExerciseOrSuperset[];
  name?: string;
  id?: string;
}

export interface Routine {
  id: string;
  name: string;
  description?: string;
  // If a routine has start date, it is linked to a user
  localStartDate?: string;
  // Duration in days
  duration: number;
  history?: RoutineChange[];
  isExpired?: boolean;
  // Campo calculado para el progreso de la rutina
  progress?: number | null;

  // References
  nextRoutine?: Routine;
  exerciseDays: ExerciseDay[];
  externalUser?: ExternalUserShort;
  organizationId: string;
}

export interface RoutineTableEntry extends Routine {
  routineType: ROUTINE_TYPES;
  remainingDays: number;
  hasNextRoutine: boolean;
}

// Routine detail
interface BaseRoutineDetailExercise extends BaseRoutineExercise {
  name: string;
  videoUrl?: string;
  imageUrl?: string;
}
interface RoutineDetailRepetitionExercise extends BaseRoutineDetailExercise {
  repetitions?: number;
}
interface RoutineDetailDurationExercise extends BaseRoutineDetailExercise {
  duration?: number;
}
type RoutineDetailExercise = RoutineDetailRepetitionExercise | RoutineDetailDurationExercise;

export interface RoutineDetail extends Routine {
  exercises: RoutineDetailExercise[];
}

export interface RoutineAlertDto {
  numberOfRoutinesEndingSoon: number;
  patientsWithoutRoutine?: { id: string; fullName: string }[];
}
